import React, { Component } from 'react';
import Container from '../../components/Container';
import { Grid, Drawer,List, ListItem,ListItemIcon } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import CustomTypo from '../../components/CustomTypo';
import { myAccountConfig } from '../../../portal.menu.config';
import DrawerCustom from '../../components/DrawerCustom';
import { domainName } from '../../../portal.config';
import { getAppCfg } from '../../utils/common';

const styles = theme => ({
    icon: {
        backgroundColor:'rgba(255,255,255,0.1)',
        borderRadius: theme.spacing(8),
        width: theme.spacing(6),
        height: theme.spacing(6),
        padding: theme.spacing(2),
    },
    listItem: {
        padding: theme.spacing(4),
    },
});
function MyAccountView(props) {

    const getIcon = (icon, classes) =>{
        var MyIcon = icon;
        return <MyIcon className={classes} />
    }
    const {classes, t, onClickItem } = props
    const app_config = getAppCfg();
    var isOrder = app_config && app_config.features && app_config.features.ordering ? app_config.features.ordering : false;
    const isRewards = app_config && app_config.features && app_config.features.rewards ? app_config.features.rewards : false;
    var isMultitenancy = app_config && app_config.features && app_config.features.business_network && app_config.features.business_network_details && app_config.features.business_network_details.multitenancy ? true : false;
    let spendPreference = app_config && app_config.features && app_config.features.rewards_details && app_config.features.rewards_details.automatic_spends;
    let return_cashback = app_config && app_config.features && app_config.features.rewards_details && app_config.features.rewards_details.return_cashback
    let customer_selfservice_purchases = app_config && app_config.features && app_config.features.rewards_details && app_config.features.rewards_details.customer_selfservice_purchases
    const cardRewards = isRewards&&return_cashback&&!isMultitenancy;
    const spending_preferences = spendPreference || customer_selfservice_purchases
    let branches = domainName;
    if (!myAccountConfig[branches]){
        branches = 'release'
    }
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={()=>props.handleDrawerOtherToggle('my_account')}
                title = {t('my_account')}
                children={                    
                    <Grid item>
                        <List>
                            {myAccountConfig[branches].map((item, index) =>   (item.id=='my_cards_orders' && isOrder) ||
                                                                                (item.id=='my_cards_rewards' && cardRewards) ||
                                                                                (item.id=='participating_schemes' && isRewards) ||
                                                                                (item.id=='transactions' && isRewards) ||
                                                                                (item.id=='spending_preferences' && spending_preferences) ? (
                                <ListItem button disabled={!item.enable} key={index} className={ classes.listItem} onClick={() => onClickItem(item.id)}>
                                    <ListItemIcon>{getIcon(item.icon, classes.icon)}</ListItemIcon>
                                    <CustomTypo variant='subtitle1' color='onPrimary' >{t(item.title)}</CustomTypo>
                                </ListItem>
                            ) : null)}
                        </List>
                </Grid>}/>
        </div>
    );
}
export default withStyles(styles)(withTranslation()(MyAccountView));